import { createSelector } from 'reselect';

const comments = (state) => state.get('comment');

export const getAllComments = createSelector(comments, (comments) => comments);

export const getAllCommentsForLesson = (lessonId) =>
  createSelector(getAllComments, (comments) => comments.get(lessonId));
